
import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="py-12 bg-[#0d1222] border-t border-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="flex items-center justify-center space-x-3 mb-4">
          <img
            src={`${process.env.PUBLIC_URL}/alethiaSystemsLogoChevrons.png`}
            alt="Aletheia Systems Logo - Identity Verification"
            className="h-8 w-auto"
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = 'https://placehold.co/40x40/06b6d4/0d1222?text=AS';
            }}
          />
          <span className="text-2xl font-bold text-white tracking-wider">
            Aletheia<span className="text-accent-cyan">Systems</span>
          </span>
        </div>
        <div className="flex justify-center space-x-6 text-text-medium text-sm mb-6">
          <Link to="/privacy-policy" className="hover:text-primary transition duration-300">Privacy & Consumer Rights</Link>
          <Link to="/cookie-policy" className="hover:text-primary transition duration-300">Cookie Policy</Link>
          <Link to="/terms-of-use" className="hover:text-primary transition duration-300">Terms of Service</Link>
          <Link to="/accessibility" className="hover:text-primary transition duration-300">Accessibility</Link>
        </div>
        <p className="text-sm text-gray-500 mt-8">
          &copy; Copyright {new Date().getFullYear()} Aletheia Systems. All Rights Reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
